// in src/posts.js
import React from 'react';
import {SelectField, ReferenceManyField, BooleanField, ImageField, ImageInput, DeleteButton, BooleanInput, ShowButton, DateField, RichTextField, Show, SimpleShowLayout, SimpleList, Filter, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import Dropzone from 'react-dropzone'
import { RichTextInput } from 'ra-input-rich-text';
import InputUploadInput from '../mui/field/UploadInput';
import { useMediaQuery } from '@mui/material';

//Utils
import Validators from './renderFields/validatorsFields';

const SubPageFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="title" alwaysOn />
    </Filter>
);

export const SubPageList = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Listar Sub páginas" filters={<SubPageFilter />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.title}
                    secondaryText={record => record.pageId}  // Adjusted to show pageId
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="title" label="Título"/>
                    <ReferenceField label="Página ID" source="pageId" reference="pages">
                        <TextField source="page" />
                    </ReferenceField>
                    <RichTextField source="description" label="Descripción"/>
                    <ImageField source="image" label="Imagen"/>
                    <BooleanField source="state" label="Estado"/>
                    <EditButton />
                    <ShowButton />
                    <DeleteButton />
                </Datagrid>
            )}
        </List>
    );
};
const SubPageTitle = ({ record }) => {
    return <span>Sub Página {record ? `"${record.title}"` : ''}</span>;
};

const validateFields = (values) => {
    const errors = {};
    
    if (!values.title) {
      errors.title = 'El título es obligatorio';
    }
   
    if (!values.pageId) {
      errors.pageId = 'La página es obligatoria';
    }
 
    if (!values.description) {
      errors.description = 'La descripción es obligatoria';
    }
 
    if (values.state === undefined) {
      errors.state = 'El estado es obligatorio';
    }
 
    return errors;
};

export const SubPageEdit = (props) => (
    <Edit title={<SubPageTitle />} {...props}>
        <SimpleForm validate={validateFields}>
            <TextInput source="id" disabled />
            <TextInput source="title" label="Título" />
            <InputUploadInput source="image" label="Imagen" />
            <ReferenceInput label="Página" source="pageId" reference="pages">
                <SelectInput optionText="page" source="pageId" />
            </ReferenceInput>
            <RichTextInput source="description" label="Descripción" />
            <BooleanInput label="Estado" source="state" />
        </SimpleForm>
    </Edit>
);

export const SubPageCreate = (props) => (
    <Create title="Crear Sub Página" {...props}>
        <SimpleForm validate={validateFields}>
            <TextInput source="title" label="Título" />
            <InputUploadInput source="image" label="Imagen" isRequired={false} />
            <ReferenceInput  label="Página" source="pageId" reference="pages" filter={{ sub_page: true }} allowEmpty>
                <SelectInput optionText="page" />
            </ReferenceInput>
            <RichTextInput source="description" label="Descripción" isRequired={true} validation={{ required: true }}/>
            <BooleanInput label="Estado" source="state" defaultValue={true} />
        </SimpleForm>
    </Create>
);

export const SubPageShow = (props) => (
    <Show title={<SubPageTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="title" label="Título"/>
            <RichTextField source="description" label="Descripción"/>
            <ImageField source="image" label="Imagen"/>
            <BooleanField source="state" label="Estado"/>
            <DateField label="Fecha de Actualización" source="updatedAt" />
            <DateField label="Fecha de Publicación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);
